export const vossSubscriptionConnectionType = {
    Collaboration: 0
};